/**
 * @copyright (C) 2023, Rsupport. All rights reserved
 *
 * @license
 * This software and/or source code may be used, copied and/or disseminated only
 * with the written permission of Rsupport, or in accordance with the terms
 * and conditions stipulated in the agreement/contract under which the software
 * and/or source code has been supplied by Rsupport or its affiliates.
 * Unauthorized use, copying, or dissemination of this file, via any medium, is
 * strictly prohibited, and will constitute an infringement of copyright.
 **/

import { DependencyList } from "react";
import { fromEvent } from "rxjs";
import { useAutoEvent } from "../hooks";

type StorageMonitorOptions = {
	onStorageChanged: (event: StorageEvent) => void;
	key: string | string[];
	storage: Storage | null;
};

/**
 * 브라우저 storage의 키값 변경 여부를 모니터링 합니다.
 * @param options StorageMonitorOptions
 */
export default function useStorageMonitor(options: StorageMonitorOptions, deps: DependencyList = []) {
	const { onStorageChanged, key, storage } = options;

	useAutoEvent(
		[
			{
				event: fromEvent<StorageEvent>(window, "storage"),
				handler(ev: StorageEvent) {
					if (storage !== null && ev.storageArea !== storage) return;
					if (Array.isArray(key)) {
						if (ev.key && key.includes(ev.key)) {
							onStorageChanged(ev);
						}
					} else {
						const doFire = key === "any" || key === ev.key;
						if (doFire) {
							onStorageChanged(ev);
						}
					}
				}
			}
		],
		deps
	);
}
